module.exports = __webpack_public_path__ + "img/generic-quickstart.d700453.webp";